import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import styles from './IconedListItem.module.css'

interface IconedListItemProps extends BasicStyledComponent {
  icon: React.VFC<BasicStyledComponent>
  iconClassName?: string
}

const IconedListItem: React.FC<IconedListItemProps & React.PropsWithChildren> = ({
  children,
  className,
  iconClassName,
  icon: Icon,
}) => (
  <div className={clsx(styles.container, className)}>
    <Icon className={clsx(styles.icon, iconClassName)} />
    {children}
  </div>
)

export default IconedListItem
